import { render } from "./DivisionPlanView.vue?vue&type=template&id=b84a5a9e"
import script from "./DivisionPlanView.vue?vue&type=script&lang=js"
export * from "./DivisionPlanView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__